import React, { useId } from "react";
import { Box, Link, TextField, Typography } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const PRIMARIO = "#5656FF";
export const TITULO = "#0b0060";
export const FUENTE = "Bricolage Grotesque";
export const BORDE = "#e4e4e7";
export const TEXTO_SECUNDARIO = "#71717a";

export const estiloInput = {
  "& .MuiOutlinedInput-root": {
    fontSize: 14,
    borderRadius: "8px",
    bgcolor: "#fff",
    "& fieldset": { borderColor: "#d4d4d8" },
    "&:hover fieldset": { borderColor: "#a1a1aa" },
    "&.Mui-focused fieldset": { borderColor: PRIMARIO, borderWidth: 1 },
    "&.Mui-focused": { boxShadow: "0 0 0 3px rgba(86, 86, 255, 0.15)" },
    "&.Mui-disabled": { bgcolor: "#f4f4f5" },
  },
  "& .MuiInputBase-input::placeholder": { color: "#a1a1aa", opacity: 1 },
};

// Seccion: bloque con título grande; las subsecciones van adentro sin otra caja.
export const Seccion = ({ titulo, accion, children, sx }) => (
  <Box sx={{ border: `1px solid ${BORDE}`, borderRadius: "12px", bgcolor: "#fff", p: { xs: 2, sm: 3 }, ...sx }}>
    {(titulo || accion) && (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, mb: 2 }}>
        <Typography sx={{ fontFamily: FUENTE, fontWeight: 700, fontSize: 20, color: TITULO }}>{titulo}</Typography>
        {accion}
      </Box>
    )}
    {children}
  </Box>
);

export const Subtitulo = ({ children, detalle, accion }) => (
  <Box sx={{ mb: 1.5 }}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Typography sx={{ fontWeight: 600, fontSize: 15, color: TITULO }}>{children}</Typography>
      {accion}
    </Box>
    {detalle && <Typography sx={{ fontSize: 13, color: TEXTO_SECUNDARIO, mt: 0.5 }}>{detalle}</Typography>}
  </Box>
);

// Campo: etiqueta chica arriba del input (sin label flotante) y ayuda opcional abajo.
export const Campo = ({ etiqueta, ayuda, sx, ...props }) => {
  const id = useId();
  return (
    <Box sx={sx}>
      {etiqueta && (
        <Typography component="label" htmlFor={id} sx={{ display: "block", fontSize: 12, color: "#52525b", mb: 0.75 }}>
          {etiqueta}
        </Typography>
      )}
      <TextField id={id} size="small" fullWidth sx={estiloInput} {...props} />
      {ayuda && <Typography sx={{ fontSize: 12, color: TEXTO_SECUNDARIO, mt: 0.75 }}>{ayuda}</Typography>}
    </Box>
  );
};

export const LinkAyuda = ({ href, children }) => (
  <Link
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    underline="hover"
    sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, fontSize: 13, color: PRIMARIO, mt: 1.5 }}
  >
    {children}
    <OpenInNewIcon sx={{ fontSize: 14 }} />
  </Link>
);

export const Aviso = ({ children, sx }) => (
  <Box
    sx={{
      display: "flex",
      gap: 1.25,
      alignItems: "flex-start",
      p: 1.5,
      borderRadius: "8px",
      border: "1px solid rgba(86, 86, 255, 0.35)",
      bgcolor: "rgba(86, 86, 255, 0.06)",
      ...sx,
    }}
  >
    <InfoOutlinedIcon sx={{ fontSize: 18, color: PRIMARIO, mt: "1px" }} />
    <Typography sx={{ fontSize: 13, color: TITULO }}>{children}</Typography>
  </Box>
);

export const estiloSwitch = {
  "& .MuiSwitch-switchBase.Mui-checked": { color: PRIMARIO },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { bgcolor: PRIMARIO },
};

export const Separador =() => <Box sx={{ borderTop: `1px solid ${BORDE}`, my: 3 }} />;
